import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod/v3'
import { AuditorPeopleDetailPage } from '@/components/auditor-center/AuditorPeopleDetailPage'
import { auditorPeopleSearchSchema } from '@/components/auditor-center/auditorPeopleSearch'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/people_/$employeeId',
)({
  validateSearch: auditorPeopleSearchSchema.extend({ tab: z.enum(['overview', 'training', 'policies', 'access']).catch('overview') }),
  staticData: { pageHeader: { title: 'Employee details', customHeader: true, pad: false, scroll: false } },
  component: AuditorPeopleDetailPage,
})
